export const DETAILED_INFO_TYPES = [
  { key: 'comments', i18n: 'tickets.detailed_info.comments' },
  { key: 'routes', i18n: 'tickets.detailed_info.routes' },
];

export const SMALL_DEVICE_WIDTH = 950;
